function hasReachedTarget(origin, target, current) {
    return ((origin < target && current >= target) ||
        (origin > target && current <= target));
}

export { hasReachedTarget };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@motionone/generators/dist/utils/has-reached-target.es.js
// module id = nZpq
// module chunks = 0